import { ManifestType } from "../../apiClient/models/ManifestType";

export const ARCHIVE_SUFFIX = "_cruise_archive";
export const ADDENDUM_SUFFIX = "_cruise_addendum";
export const ARCHIVE_TYPES = [
  ManifestType.SEALED_CRUISE_ARCHIVE,
  ManifestType.OPEN_CRUISE_ARCHIVE,
];
export const ADDENDUM_TYPES = [ManifestType.CRUISE_ADDENDUM];
export const PAGE_SIZE = 500;
export const SCROLL_THRESHOLD_PX = 200;
